import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";

const AddPurchaseOrder = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const selectInputRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [companyData, setCompanyData] = useState([]);
    const [products, setProducts] = useState([]);
    const [items, setItems] = useState([]);
    const [productData, setProductData] = useState({
        name: "",
        product_id: "",
        sub_product_id: "",
        qty: "",
    });
    const [formData, setFormData] = useState({
        "supplier_id": "",
        "purchase_order_number":"",
        "prefix": "",
        "items": []
    });
    const styles = {
        menu: (baseStyles, state) => ({
            ...baseStyles,
            marginTop: 2,
            zIndex: 999,
        }),
    };
        const getPurchaseOrder = () => {
        axios.post(API_URL.PURCHASE_ORDER_LATEST, {}).then((res) => {
            if (res.data.status === 1) {
                setFormData({ ...formData, prefix: res.data.prefix, purchase_order_number: res.data.data });
            }
        });
    };

    const getEdit = () => {
        axios.post(API_URL.PURCHASE_ORDER_GET, { id: id }).then((res) => {
            if (res.data.status == 1) {
                setFormData({
                    "purchase_order_number": (res.data.data.purchase_order_number) ? res.data.data.purchase_order_number : "",
                    "remarks": (res.data.data.remarks) ? res.data.data.remarks : "",
                    "prefix": (res.data.data.prefix) ? res.data.data.prefix : "",
                    "items": [],
                });
                let rows = res.data.data.items.map((row) => {
                    return {
                        name: row.product.name + (row.subproduct ? " - " + row.subproduct.name : ""),
                        qty: row.qty,
                        product_id: row.product_id,
                        sub_product_id: row.sub_product_id
                    }
                });
                setItems(rows);
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
        });
    }

    const getProducts = () => {
        axios.post(API_URL.MY_PRODUCT_WITH_SUB_LIST, {}).then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
                res.data.data.map((raw) => {
                    raw.label = raw.name;
                    raw.value = raw.id;
                });
                setProducts(res.data.data);
            } else {
                setProducts([]);
            }
        });
    };
    const setProductValue = (e) => {
        if (e) {
            setProductData({
                ...productData,
                name: e ? e.label : "",
                product_id: e ? e.product_id : null,
                sub_product_id: e ? e.sub_product_id : null,
            });
        }
    };
    const addRow = () => {
        if (
            productData.product_id &&
            productData.qty
        ) {
            let cloneItems = [...items];
            cloneItems.push(productData);
            setItems(cloneItems);
            setProductData({
                name: "",
                product_id: "",
                sub_product_id: "",
                qty: "",
            });
            selectInputRef.current.clearValue();
        }
    };
    const updateValue = (name, amt, value, k) => {
        const copyData = [...items]
        if (copyData[k]) {
            copyData[k][name] = value;
        }
        setItems(copyData);
    }

    const deleteRow = (index) => {
        const copyData = [...items]
        let newData = copyData.filter((e, key) => {
            return key != index;
        });
        setItems(newData)
    }

    const calculations = () => {
        let total_qty = 0;
        items.forEach((row) => {
            total_qty += parseFloat(row.qty);
        });
        setFormData({
            ...formData,
            total_qty: total_qty,
        });
    }

        const savePurchaseOrder = () => {
        let payload = { ...formData };
        payload.items = [...items];
        const pUrl = API_URL.PURCHASE_ORDER_SAVE;
        if (id) {
            payload.id = id;
        }
        setIsLoading(true);
        axios.post(pUrl, payload).then((res) => {
            if (res.data.status === 1) {
                if (id) {
                    toast.success("Updated", {
                        autoClose: 3000,

                    });
                } else {
                    toast.success("Saved", { autoClose: 3000 });
                }
                setTimeout(() => {
                    navigate("/purchase-order", { replace: true });
                }, 100);
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setIsLoading(false);
        }, (error) => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        calculations();
    }, [items])

    useEffect(() => {
        getProducts();
    }, [])

    useEffect(() => {
        if (id) {
            getEdit()
        }else{
            getPurchaseOrder()  
        }
    }, [id])
    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h1>{id ? "Edit" : "Add"} Purchase Order</h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/purchase-order"} className="btn btn-secondary">
                            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                        </Link>
                    </div>
                </div>
                <div className="col-12">
                    <form onSubmit={(event) => event.preventDefault()}>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="card">
                                    <h4 className="card-header">PO Details</h4>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="pan_no">Prefix</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled
                                                        value={formData.prefix ? formData.prefix : ""}
                                                    />
                                                </div>
                                            </div>
                                             <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="invoiceno">Purchase Order No</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={formData.purchase_order_number}
                                                        onChange={(e) => setFormData({ ...formData, purchase_order_number: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <h4 className="card-header">Product Details</h4>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Product</label>
                                                    <Select
                                                        ref={selectInputRef}
                                                        options={products}
                                                        styles={styles}
                                                        onChange={(e) => {
                                                            setProductValue(e);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Qty</label>
                                                    <input
                                                        type="number"
                                                        onChange={(e) => {
                                                            setProductData({
                                                                ...productData,
                                                                qty: e.target.value,
                                                                amount:
                                                                    e.target.value * productData.rate
                                                                        ? e.target.value * productData.rate
                                                                        : 0,
                                                            });
                                                        }}
                                                        value={productData.qty}
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-1">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <div>
                                                        <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => addRow()} className="simple-icon-plus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            {items.length > 0 &&
                                <table className='table table-hover'>
                                    <thead className='thead'>
                                        <tr>
                                            <th>#</th>
                                            <th style={{ width: '45%' }}>Product</th>
                                            <th>Qty</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            items.map((e, k) => {
                                                return <tr key={k}>
                                                    <td>{k + 1}</td>
                                                    <td style={{ width: '45%' }}>{e.name}</td>
                                                    <td><input type="number" onChange={(event) => { updateValue('qty', 'amount', event.target.value, k) }} className="form-control form-control-sm" value={e.qty} /></td>
                                                    <td style={{ cursor: "pointer", textAlign: 'right' }}>
                                                        <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => { deleteRow(k) }} className="simple-icon-close text-danger"></i>
                                                    </td>
                                                </tr>
                                            })
                                        }
                                        <tr className="border-top">
                                            <td></td>
                                            <td className="text-right"><strong>Total Qty</strong></td>
                                            <td><strong>{formData.total_qty}</strong></td>
                                            <td></td>
                                        </tr>
                                        <tr className="border-top">
                                            <td className="border-end" rowSpan={2} colSpan={4}>
                                                <label>Remarks</label>
                                                <input type={'text'} maxLength={255} value={formData.remarks} placeholder="remarks" className='form-control' onChange={(e) => setFormData({ ...formData, remarks: e.target.value })} />
                                            </td>   
                                        </tr>
                                    </tbody>
                                </table>
                            }
                        </div>
                    </form>
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                        <div className="form-group text-right">
                            <button
                                type="button"
                                onClick={savePurchaseOrder}
                                disabled={isLoading}
                                className="btn btn-primary" >
                                {isLoading ? <span className="spinner-border spinner-border-sm me-2" role="status"></span> : null}
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddPurchaseOrder;